/*
 Relies on 'this' being an instance of a
 Vuex Store being bound into function
 at run time
 [e.g. thisFunction.bind(vuexStoreInstance)]
 */

function AuthCheckInterceptor (authUri) {
  function foo (req, next) {
    if (req.url.match(authUri)) {
      req.headers.set('X-Authentication', this.state.authentication.token)
    }
    next()
  }
  return foo
}
export default AuthCheckInterceptor



// WEBPACK FOOTER //
// ./src/modules/authentication/middleware/AuthCheckInterceptor.js